var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { ModalcloseReason } from '../../../../node_modules/hsg';
var AuthSuccessRegistrationComponent = /** @class */ (function (_super) {
    __extends(AuthSuccessRegistrationComponent, _super);
    function AuthSuccessRegistrationComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthSuccessRegistrationComponent.prototype.submit = function () {
        var data = this.modalService.data;
        delete data["ProcessSuccess"];
        this.modalService.close(data, ModalcloseReason.action);
    };
    return AuthSuccessRegistrationComponent;
}(AuthBaseComponent));
export { AuthSuccessRegistrationComponent };
